// removed by extract-text-webpack-plugin
module.exports = {"vehicle__image":"PAEditVehicle-hashed__vehicle__image__1Wa_9","vehicle__imageText":"PAEditVehicle-hashed__vehicle__imageText__d_Zak"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/directives/pa-edit-vehicle/PAEditVehicle-hashed.scss
// module id = 1253
// module chunks = 0